var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"inside",class:{ 'no-padding-bottom': _vm.isManagementPage }},[_c('RouterView')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }